<template>
  <div>
    <b-card-title class="mb-2">
      {{ $t('settings.coordinates.dms.title') }}
    </b-card-title>
    <b-card-text class="mb-3 text-muted">
      {{ $t('settings.coordinates.dms.description') }}
    </b-card-text>

    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <!-- Decimal Precision -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.dms.decimal_precision')"
            label-for="dms-decimal-precision"
            :description="$t('settings.coordinates.dms.decimal_precision_desc')"
          >
            <b-form-input
              id="dms-decimal-precision"
              v-model.number="form.decimal_precision"
              type="number"
              min="1"
              max="15"
              step="1"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Seconds Decimal Places -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.dms.seconds_decimal_places')"
            label-for="dms-seconds-decimal"
            :description="$t('settings.coordinates.dms.seconds_decimal_places_desc')"
          >
            <b-form-input
              id="dms-seconds-decimal"
              v-model.number="form.seconds_decimal_places"
              type="number"
              min="0"
              max="6"
              step="1"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Example Display -->
      <b-alert
        show
        variant="info"
        class="mt-2"
      >
        <div class="alert-body">
          <feather-icon
            icon="InfoIcon"
            class="mr-50"
          />
          <span>
            {{ $t('settings.coordinates.dms.example') }}:
            <strong>30°3'45.36"N, 31°20'46.32"E</strong>
          </span>
        </div>
      </b-alert>

      <!-- Actions -->
      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="loading"
          @click="resetForm"
        >
          {{ $t('common.reset') }}
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-50"
          />
          {{ $t('common.save') }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BSpinner,
  BAlert,
} from 'bootstrap-vue'

export default {
  name: 'DmsSettingsForm',
  components: {
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BAlert,
  },
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        decimal_precision: 6,
        seconds_decimal_places: 2,
      },
    }
  },
  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(newSettings) {
        if (newSettings && Object.keys(newSettings).length > 0) {
          this.form = { ...this.form, ...newSettings }
        }
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('save', { ...this.form })
    },
    resetForm() {
      if (this.settings && Object.keys(this.settings).length > 0) {
        this.form = { ...this.settings }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mr-50 {
  margin-right: 0.5rem;
}
</style>
